export const translations = {
  de: {
    nav: {
      home: "Start",
      biochar: "Bio-Pflanzenkohle",
      production: "Produktion",
      applications: "Anwendungen",
      documentation: "Dokumentation",
      market: "Markt",
      contact: "Kontakt",
      team: "Team",
      menu: "Menü",
      cta: "Projektmenge anfragen",
    },
    hero: {
      badge: "SRC Global GmbH · Climate-Tech & Carbon Removal",
      titleLine1: "Black Carbon.",
      titleLine2: "Green Future.",
      subtitle:
        "Premium Bio-Pflanzenkohle aus kontrollierter europäischer Paulownia-Biomasse – für Bodenverbesserung, Rekultivierung, Carbon Storage und professionelle Projektanwendungen.",
      ctaPrimary: "Projektmenge anfragen",
      ctaSecondary: "Dokumentation ansehen",
      imageCaption: "Bio-Pflanzenkohle · Paulownia",
      imageTag: "Makro",
      stats: [
        { value: "EBC", label: "orientierte Qualität" },
        { value: "100%", label: "europäische Biomasse" },
        { value: "MRV", label: "dokumentierte Chargen" },
      ],
    },
    strategic: {
      label: "Strategischer Rohstoff",
      title: "Bio-Pflanzenkohle – vom Nischenprodukt zum strategischen Rohstoff.",
      text: "Bio-Pflanzenkohle entwickelt sich von einem Nischenprodukt zu einem strategischen Rohstoff. Sie ist physisch vorhanden, lagerfähig, transportierbar, einsetzbar und dokumentierbar – ein reales, handelbares Produkt mit Anwendungen in Landwirtschaft, Substraten, Bodenverbesserung, Rekultivierung und Carbon Removal.",
      attributes: ["Physisch vorhanden", "Lagerfähig", "Transportierbar", "Einsetzbar", "Dokumentierbar"],
    },
    production: {
      label: "Produktionsansatz",
      title: "Ein kontrollierter Produktionsansatz – von der Biomasse bis zur dokumentierten Pflanzenkohle.",
      text: "NeroChar verbindet kontrollierte Kultivierung, eigene Bewirtschaftung, Pyrolyse, Laboranalysen und internationale Vermarktung zu einem physischen Produkt mit klarer Herkunft und nachvollziehbarer Produktion.",
      steps: [
        { title: "Kontrollierte Paulownia-Kultivierung", text: "Definierte Anbauflächen in Kroatien." },
        { title: "Eigene Bewirtschaftung & Qualitätskontrolle", text: "Durchgängige Verantwortung über die Biomasse." },
        { title: "Produktion durch Pyrolyse", text: "Umwandlung unter Sauerstoffausschluss." },
        { title: "Laboranalysen & Chargendokumentation", text: "Messbare, nachvollziehbare Qualitätsparameter." },
        { title: "Internationale Vermarktung", text: "B2B-Lieferung an professionelle Abnehmer." },
      ],
    },
    advantages: {
      label: "Vorteile",
      title: "Vorteile der Bio-Pflanzenkohle.",
      subtitle: "Vier Eigenschaften, die Bio-Pflanzenkohle zu einem hochwertigen, dokumentierbaren Rohstoff machen.",
      cards: [
        { title: "Porenreich", text: "Große innere Oberfläche möglich." },
        { title: "Dauerhaft", text: "Langfristige Kohlenstoffspeicherung." },
        { title: "Wasserstark", text: "Unterstützt Wasserhaltefähigkeit im Boden." },
        { title: "Dokumentierbar", text: "Chargenbasiert, messbar und nachvollziehbar." },
      ],
    },
    applications: {
      label: "Anwendungen",
      title: "Ein Rohstoff für Boden, Landwirtschaft und Klima.",
      subtitle: "Bio-Pflanzenkohle von NeroChar findet Anwendung über die gesamte Wertschöpfungskette professioneller Boden- und Carbon-Projekte.",
      items: [
        { title: "Landwirtschaft", text: "Bodenstruktur und Nährstoffmanagement." },
        { title: "Bodenverbesserung", text: "Aktivierung und Aufwertung von Böden." },
        { title: "Rekultivierung", text: "Wiederherstellung degradierter Flächen." },
        { title: "Agroforst", text: "Integrierte land- und forstwirtschaftliche Systeme." },
        { title: "Substrate", text: "Hochwertige Substrat-Komponente." },
        { title: "Carbon Storage", text: "Langfristige Kohlenstoffeinlagerung." },
        { title: "Carbon Removal Projekte", text: "Dokumentierte Senkenleistung." },
        { title: "Professionelle Projektanwendungen", text: "Maßgeschneiderte Projektmengen." },
      ],
    },
    certification: {
      label: "Zertifizierung & MRV",
      title: "Vertrauen durch anerkannte Standards und nachvollziehbare Dokumentation.",
      text: "NeroChar richtet die Produktion an anerkannten Standards und Methodiken aus – insbesondere am European Biochar Certificate, der Puro.earth Biochar Methodology und einem MRV-orientierten Dokumentationsansatz.",
      standards: [
        { name: "European Biochar Certificate", abbr: "EBC" },
        { name: "Puro.earth Biochar Methodology", abbr: "Puro.earth" },
        { name: "Measurement, Reporting & Verification", abbr: "MRV" },
      ],
      mrvTitle: "MRV-Dokumentation umfasst",
      mrv: [
        "Dokumentierte Biomasseherkunft",
        "Klare Chargenlogik",
        "Produktionsdaten der Pyrolyse",
        "Laboranalysen",
        "Qualitätsparameter",
        "Verwendungs- oder Vermarktungsnachweis",
        "Carbon-Storage-Dokumentation",
        "Vermeidung von Doppelzählung",
      ],
    },
    market: {
      label: "Markt & Wertpotenzial",
      title: "Marktwert & Premium-Positionierung.",
      text: "Der Marktpreis von Bio-Pflanzenkohle hängt von mehreren Faktoren ab. NeroChar positioniert sich als hochwertige, dokumentierte Premium-Biochar für professionelle Boden-, Rekultivierungs- und Carbon-Storage-Anwendungen.",
      driversTitle: "Preis- und Wertfaktoren",
      drivers: ["Qualität", "Körnung", "Zertifizierung", "Menge", "Anwendung", "Lieferfähigkeit"],
    },
    whyNero: {
      label: "Warum NeroChar",
      title: "Ein dokumentiertes, handelbares Premium-Produkt – mit klarer Herkunft.",
      points: [
        "Kontrollierte Herkunft",
        "Europäische Paulownia-Biomasse",
        "Produktion in Kroatien",
        "Eigene Qualitätskontrolle",
        "Physisches und handelbares Produkt",
        "Dokumentation nach professionellen Standards",
        "Internationale Vermarktung",
        "Relevant für Boden, Klima und Rohstoffmärkte",
      ],
    },
    comingSoon: {
      label: "Coming Soon",
      badge: "In Entwicklung",
      title: "Die erste App für transparente Bio-Pflanzenkohle-Produktion.",
      subtitle: "Marktpreise, Chargendokumentation und Carbon-Storage-Nachweise – transparent gebündelt in einer App.",
      features: ["Echtzeit-Marktpreise", "Chargendokumentation", "Carbon Storage", "MRV-Transparenz"],
    },
    contact: {
      label: "Projektanfrage",
      title: "Sprechen Sie mit uns über Bio-Pflanzenkohle, Projektmengen und Carbon-Storage-Anwendungen.",
      subtitle: "Wir beraten Geschäftskunden, Projektpartner und Carbon-Removal-Akteure zu Qualität, Mengen und Dokumentation.",
      form: {
        name: "Name",
        company: "Unternehmen",
        email: "E-Mail",
        phone: "Telefon",
        interest: "Interessensbereich",
        interestOptions: ["Bodenverbesserung", "Rekultivierung", "Carbon Storage", "Substrate / Agrar", "Investment / Partnerschaft", "Sonstiges"],
        message: "Ihre Nachricht",
        submit: "Projektanfrage senden",
        sending: "Wird gesendet …",
        success: "Vielen Dank! Ihre Anfrage wurde übermittelt. Wir melden uns in Kürze.",
        error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut oder schreiben Sie an info@nerochar.com.",
        namePh: "Vor- und Nachname",
        companyPh: "Firmenname",
        emailPh: "name@unternehmen.com",
        phonePh: "+41 ...",
        messagePh: "Beschreiben Sie kurz Ihr Projekt, Mengen und Zeitrahmen.",
      },
      companyTitle: "Kontaktinformationen",
      company: "SRC Global GmbH",
      address1: "Chaltenbodenstrasse 26",
      address2: "8834 Schindellegi, Schweiz",
      phoneLabel: "Telefon",
      phone: "044 722 32 35",
      emailLabel: "E-Mail",
      email: "info@nerochar.com",
    },
    video: {
      label: "Einblick",
      title: "NeroChar in Bewegung.",
    },
    team: {
      overline: "Unser Team",
      titleLine1: "Die Menschen",
      titleLine2: "hinter der Vision",
      intro: "Ein interdisziplinäres Team aus Experten vereint Erfahrung in Forstwirtschaft, Technologie, Finanzen und Nachhaltigkeit, um die Carbon Removal Industrie in Europa voranzutreiben.",
      members: [
        { name: "Gerold Alexander Auer", role: "Verwaltungsrat", img: "/team/auer.png" },
        { name: "Egzon Imeri", role: "Mitglied der Geschäftsleitung", img: "/team/imeri.png" },
        { name: "Mario Marjanovic", role: "Mitglied der Geschäftsleitung", img: "/team/marjanovic.png" },
        { name: "Tobias Häppt", role: "Mitglied der Geschäftsleitung", img: "/team/haeppt.png" },
        { name: "Stéphane Garcia", role: "Mitglied der Geschäftsleitung", img: "/team/garcia.png" },
        { name: "Katharina Goldsachs", role: "Customer Relations", img: "/team/goldsachs.png" },
      ],
    },
    legal: {
      agb: {
        kicker: "Rechtliches",
        title: "Allgemeine Geschäftsbedingungen",
        updated: "Stand: Juni 2026",
        sections: [
          { h: "Geltungsbereich", body: ["Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Geschäftsbeziehungen, Angebote, Lieferungen und Leistungen von NeroChar, einem Geschäftsbereich der SRC Global GmbH (nachfolgend „NeroChar“). Abweichende Bedingungen des Kunden werden nur wirksam, wenn NeroChar ihnen ausdrücklich schriftlich zustimmt."] },
          { h: "Vertragspartner", body: ["Vertragspartner ist die SRC Global GmbH, Chaltenbodenstrasse 26, 8834 Schindellegi, Schweiz."] },
          { h: "Angebote und Vertragsabschluss", body: ["Angebote von NeroChar sind freibleibend und unverbindlich, sofern sie nicht ausdrücklich als verbindlich bezeichnet werden. Ein Vertrag kommt erst mit schriftlicher Auftragsbestätigung durch NeroChar oder mit Ausführung der Lieferung zustande."] },
          { h: "Preise und Zahlung", body: ["Alle Preise verstehen sich, sofern nicht anders angegeben, exklusive Mehrwertsteuer sowie Verpackungs-, Transport- und Versicherungskosten. Rechnungen sind innerhalb der vereinbarten Frist ohne Abzug zahlbar."] },
          { h: "Lieferung und Mengen", body: ["Liefertermine und Projektmengen werden individuell vereinbart. Teillieferungen sind zulässig, soweit sie dem Kunden zumutbar sind. Verzögerungen aufgrund höherer Gewalt berechtigen NeroChar, die Lieferung entsprechend zu verschieben."] },
          { h: "Qualität und Dokumentation", body: ["NeroChar richtet die Produktion an anerkannten Standards aus und stellt chargenbezogene Dokumentation bereit. Massgeblich für die geschuldete Beschaffenheit sind die jeweils vereinbarten Spezifikationen."] },
          { h: "Eigentumsvorbehalt", body: ["Gelieferte Ware bleibt bis zur vollständigen Bezahlung Eigentum von NeroChar."] },
          { h: "Gewährleistung und Haftung", body: ["Offensichtliche Mängel sind unverzüglich nach Erhalt der Ware schriftlich anzuzeigen. Die Haftung von NeroChar beschränkt sich, soweit gesetzlich zulässig, auf Vorsatz und grobe Fahrlässigkeit."] },
          { h: "Anwendbares Recht und Gerichtsstand", body: ["Es gilt ausschliesslich schweizerisches Recht unter Ausschluss des UN-Kaufrechts (CISG). Gerichtsstand ist, soweit gesetzlich zulässig, der Sitz der SRC Global GmbH."] },
        ],
        note: "Hinweis: Dieser Text ist eine allgemeine Vorlage und ersetzt keine individuelle Rechtsberatung. Bitte lassen Sie die AGB vor der Veröffentlichung rechtlich prüfen.",
      },
      privacy: {
        kicker: "Rechtliches",
        title: "Datenschutzerklärung",
        updated: "Stand: Juni 2026",
        sections: [
          { h: "Verantwortliche Stelle", body: ["Verantwortlich für die Datenverarbeitung auf dieser Website ist die SRC Global GmbH (NeroChar), Chaltenbodenstrasse 26, 8834 Schindellegi, Schweiz.", "Telefon: 044 722 32 35 · E-Mail: info@nerochar.com"] },
          { h: "Grundsätze", body: ["Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften, insbesondere dem Schweizer Datenschutzgesetz (DSG) und, soweit anwendbar, der EU-Datenschutz-Grundverordnung (DSGVO)."] },
          { h: "Erhebung und Verarbeitung von Daten", body: ["Beim Besuch unserer Website werden technisch notwendige Daten (z. B. IP-Adresse, Browsertyp, Zugriffszeitpunkt) automatisch erfasst, um den Betrieb und die Sicherheit der Website zu gewährleisten."] },
          { h: "Kontaktformular", body: ["Wenn Sie uns über das Kontaktformular eine Anfrage senden, verarbeiten wir die von Ihnen angegebenen Daten (z. B. Name, Unternehmen, E-Mail, Telefon, Nachricht) ausschliesslich zur Bearbeitung Ihrer Anfrage."] },
          { h: "Cookies", body: ["Diese Website kann Cookies einsetzen, die für die Funktion und Verbesserung des Angebots erforderlich sind. Sie können Ihren Browser so einstellen, dass Cookies abgelehnt oder gelöscht werden."] },
          { h: "Weitergabe an Dritte", body: ["Eine Weitergabe Ihrer Daten an Dritte erfolgt nur, soweit dies zur Vertragserfüllung erforderlich ist oder eine gesetzliche Grundlage besteht."] },
          { h: "Ihre Rechte", body: ["Sie haben das Recht auf Auskunft, Berichtigung, Löschung sowie Einschränkung der Verarbeitung Ihrer personenbezogenen Daten. Bitte wenden Sie sich hierzu an info@nerochar.com."] },
          { h: "Datensicherheit", body: ["Wir treffen angemessene technische und organisatorische Massnahmen, um Ihre Daten gegen Verlust, Missbrauch und unbefugten Zugriff zu schützen."] },
          { h: "Änderungen", body: ["Wir behalten uns vor, diese Datenschutzerklärung anzupassen, um sie an geänderte Rechtslagen oder Funktionen der Website anzupassen."] },
        ],
        note: "Hinweis: Dieser Text ist eine allgemeine Vorlage und ersetzt keine individuelle Rechtsberatung. Bitte lassen Sie die Datenschutzerklärung vor der Veröffentlichung rechtlich prüfen.",
      },
    },
    footer: {
      tagline: "Premium Bio-Pflanzenkohle aus kontrollierter europäischer Paulownia-Biomasse.",
      rights: "Alle Rechte vorbehalten.",
      brandLine: "NeroChar ist ein Geschäftsbereich der SRC Global GmbH.",
      partnersTitle: "Partner & Standards",
      contactTitle: "Kontakt",
      agb: "AGB",
      privacy: "Datenschutz",
    },
  },

  en: {
    nav: {
      home: "Home",
      biochar: "Biochar",
      production: "Production",
      applications: "Applications",
      documentation: "Documentation",
      market: "Market",
      contact: "Contact",
      team: "Team",
      menu: "Menu",
      cta: "Request project volume",
    },
    hero: {
      badge: "SRC Global GmbH · Climate-Tech & Carbon Removal",
      titleLine1: "Black Carbon.",
      titleLine2: "Green Future.",
      subtitle:
        "Premium biochar from controlled European Paulownia biomass – for soil improvement, land reclamation, carbon storage and professional project applications.",
      ctaPrimary: "Request project volume",
      ctaSecondary: "View documentation",
      imageCaption: "Biochar · Paulownia",
      imageTag: "Macro",
      stats: [
        { value: "EBC", label: "oriented quality" },
        { value: "100%", label: "European biomass" },
        { value: "MRV", label: "documented batches" },
      ],
    },
    strategic: {
      label: "Strategic raw material",
      title: "Biochar – from niche product to strategic raw material.",
      text: "Biochar is evolving from a niche product into a strategic raw material. It is physically present, storable, transportable, usable and documentable – a real, tradable product with applications in agriculture, substrates, soil improvement, land reclamation and carbon removal.",
      attributes: ["Physically present", "Storable", "Transportable", "Usable", "Documentable"],
    },
    production: {
      label: "Production approach",
      title: "A controlled production approach – from biomass to documented biochar.",
      text: "NeroChar combines controlled cultivation, in-house management, pyrolysis, lab analysis and international marketing into a physical product with clear origin and traceable production.",
      steps: [
        { title: "Controlled Paulownia cultivation", text: "Defined growing areas in Croatia." },
        { title: "In-house management & quality control", text: "End-to-end responsibility over the biomass." },
        { title: "Production through pyrolysis", text: "Conversion in the absence of oxygen." },
        { title: "Lab analysis & batch documentation", text: "Measurable, traceable quality parameters." },
        { title: "International marketing", text: "B2B supply to professional buyers." },
      ],
    },
    advantages: {
      label: "Advantages",
      title: "Advantages of biochar.",
      subtitle: "Four properties that make biochar a high-quality, documentable raw material.",
      cards: [
        { title: "Porous", text: "Large internal surface area possible." },
        { title: "Durable", text: "Long-term carbon storage." },
        { title: "Water-retentive", text: "Supports water retention in the soil." },
        { title: "Documentable", text: "Batch-based, measurable and traceable." },
      ],
    },
    applications: {
      label: "Applications",
      title: "A raw material for soil, agriculture and climate.",
      subtitle: "NeroChar biochar is used across the entire value chain of professional soil and carbon projects.",
      items: [
        { title: "Agriculture", text: "Soil structure and nutrient management." },
        { title: "Soil improvement", text: "Activation and upgrading of soils." },
        { title: "Land reclamation", text: "Restoration of degraded land." },
        { title: "Agroforestry", text: "Integrated agricultural and forestry systems." },
        { title: "Substrates", text: "High-quality substrate component." },
        { title: "Carbon storage", text: "Long-term carbon sequestration." },
        { title: "Carbon removal projects", text: "Documented sink performance." },
        { title: "Professional project applications", text: "Tailored project volumes." },
      ],
    },
    certification: {
      label: "Certification & MRV",
      title: "Trust through recognised standards and traceable documentation.",
      text: "NeroChar aligns its production with recognised standards and methodologies – in particular the European Biochar Certificate, the Puro.earth Biochar Methodology and an MRV-oriented documentation approach.",
      standards: [
        { name: "European Biochar Certificate", abbr: "EBC" },
        { name: "Puro.earth Biochar Methodology", abbr: "Puro.earth" },
        { name: "Measurement, Reporting & Verification", abbr: "MRV" },
      ],
      mrvTitle: "MRV documentation includes",
      mrv: [
        "Documented biomass origin",
        "Clear batch logic",
        "Pyrolysis production data",
        "Laboratory analyses",
        "Quality parameters",
        "Use or marketing evidence",
        "Carbon storage documentation",
        "Avoidance of double counting",
      ],
    },
    market: {
      label: "Market & value potential",
      title: "Market value & premium positioning.",
      text: "The market price of biochar depends on several factors. NeroChar positions itself as a high-quality, documented premium biochar for professional soil, reclamation and carbon storage applications.",
      driversTitle: "Price and value drivers",
      drivers: ["Quality", "Grain size", "Certification", "Volume", "Application", "Supply capability"],
    },
    whyNero: {
      label: "Why NeroChar",
      title: "A documented, tradable premium product – with clear origin.",
      points: [
        "Controlled origin",
        "European Paulownia biomass",
        "Production in Croatia",
        "In-house quality control",
        "Physical and tradable product",
        "Documentation to professional standards",
        "International marketing",
        "Relevant for soil, climate and commodity markets",
      ],
    },
    comingSoon: {
      label: "Coming Soon",
      badge: "In development",
      title: "The first app for transparent biochar production.",
      subtitle: "Market prices, batch documentation and carbon-storage evidence – transparently bundled in one app.",
      features: ["Real-time prices", "Batch documentation", "Carbon storage", "MRV transparency"],
    },
    contact: {
      label: "Project request",
      title: "Talk to us about biochar, project volumes and carbon-storage applications.",
      subtitle: "We advise business customers, project partners and carbon-removal stakeholders on quality, volumes and documentation.",
      form: {
        name: "Name",
        company: "Company",
        email: "Email",
        phone: "Phone",
        interest: "Area of interest",
        interestOptions: ["Soil improvement", "Land reclamation", "Carbon storage", "Substrates / Agriculture", "Investment / Partnership", "Other"],
        message: "Your message",
        submit: "Send project request",
        sending: "Sending …",
        success: "Thank you! Your request has been submitted. We will get back to you shortly.",
        error: "Something went wrong. Please try again or email info@nerochar.com.",
        namePh: "First and last name",
        companyPh: "Company name",
        emailPh: "name@company.com",
        phonePh: "+41 ...",
        messagePh: "Briefly describe your project, volumes and timeframe.",
      },
      companyTitle: "Contact information",
      company: "SRC Global GmbH",
      address1: "Chaltenbodenstrasse 26",
      address2: "8834 Schindellegi, Switzerland",
      phoneLabel: "Phone",
      phone: "044 722 32 35",
      emailLabel: "Email",
      email: "info@nerochar.com",
    },
    video: {
      label: "Insight",
      title: "NeroChar in motion.",
    },
    team: {
      overline: "Our team",
      titleLine1: "The people",
      titleLine2: "behind the vision",
      intro: "An interdisciplinary team of experts combines experience in forestry, technology, finance and sustainability to advance the carbon removal industry in Europe.",
      members: [
        { name: "Gerold Alexander Auer", role: "Board of Directors", img: "/team/auer.png" },
        { name: "Egzon Imeri", role: "Member of the Executive Board", img: "/team/imeri.png" },
        { name: "Mario Marjanovic", role: "Member of the Executive Board", img: "/team/marjanovic.png" },
        { name: "Tobias Häppt", role: "Member of the Executive Board", img: "/team/haeppt.png" },
        { name: "Stéphane Garcia", role: "Member of the Executive Board", img: "/team/garcia.png" },
        { name: "Katharina Goldsachs", role: "Customer Relations", img: "/team/goldsachs.png" },
      ],
    },
    legal: {
      agb: {
        kicker: "Legal",
        title: "Terms & Conditions",
        updated: "Last updated: June 2026",
        sections: [
          { h: "Scope", body: ["These General Terms and Conditions (T&C) apply to all business relationships, offers, deliveries and services of NeroChar, a division of SRC Global GmbH (\"NeroChar\"). Deviating terms of the customer only apply if NeroChar has expressly agreed to them in writing."] },
          { h: "Contracting party", body: ["The contracting party is SRC Global GmbH, Chaltenbodenstrasse 26, 8834 Schindellegi, Switzerland."] },
          { h: "Offers and conclusion of contract", body: ["Offers by NeroChar are non-binding unless expressly designated as binding. A contract is concluded only upon written order confirmation by NeroChar or upon execution of the delivery."] },
          { h: "Prices and payment", body: ["Unless stated otherwise, all prices are exclusive of value added tax as well as packaging, transport and insurance costs. Invoices are payable within the agreed period without deduction."] },
          { h: "Delivery and volumes", body: ["Delivery dates and project volumes are agreed individually. Partial deliveries are permitted insofar as they are reasonable for the customer. Delays due to force majeure entitle NeroChar to postpone delivery accordingly."] },
          { h: "Quality and documentation", body: ["NeroChar aligns its production with recognised standards and provides batch-based documentation. The agreed specifications are decisive for the owed condition of the product."] },
          { h: "Retention of title", body: ["Delivered goods remain the property of NeroChar until full payment has been received."] },
          { h: "Warranty and liability", body: ["Obvious defects must be reported in writing immediately upon receipt of the goods. NeroChar's liability is limited, to the extent permitted by law, to intent and gross negligence."] },
          { h: "Applicable law and place of jurisdiction", body: ["Swiss law applies exclusively, excluding the UN Convention on Contracts for the International Sale of Goods (CISG). The place of jurisdiction is, to the extent permitted by law, the registered office of SRC Global GmbH."] },
        ],
        note: "Note: This text is a general template and does not constitute individual legal advice. Please have the terms reviewed legally before publication.",
      },
      privacy: {
        kicker: "Legal",
        title: "Privacy Policy",
        updated: "Last updated: June 2026",
        sections: [
          { h: "Controller", body: ["The controller responsible for data processing on this website is SRC Global GmbH (NeroChar), Chaltenbodenstrasse 26, 8834 Schindellegi, Switzerland.", "Phone: 044 722 32 35 · Email: info@nerochar.com"] },
          { h: "Principles", body: ["We treat your personal data confidentially and in accordance with statutory data protection regulations, in particular the Swiss Data Protection Act (FADP) and, where applicable, the EU General Data Protection Regulation (GDPR)."] },
          { h: "Collection and processing of data", body: ["When you visit our website, technically necessary data (e.g. IP address, browser type, time of access) is automatically recorded to ensure the operation and security of the website."] },
          { h: "Contact form", body: ["If you send us a request via the contact form, we process the data you provide (e.g. name, company, email, phone, message) exclusively to handle your request."] },
          { h: "Cookies", body: ["This website may use cookies that are necessary for the function and improvement of the service. You can set your browser to reject or delete cookies."] },
          { h: "Disclosure to third parties", body: ["Your data is only passed on to third parties insofar as this is necessary to fulfil the contract or there is a legal basis for it."] },
          { h: "Your rights", body: ["You have the right to information, correction, deletion and restriction of the processing of your personal data. Please contact info@nerochar.com for this purpose."] },
          { h: "Data security", body: ["We take appropriate technical and organisational measures to protect your data against loss, misuse and unauthorised access."] },
          { h: "Changes", body: ["We reserve the right to amend this privacy policy in order to adapt it to changed legal situations or website functions."] },
        ],
        note: "Note: This text is a general template and does not constitute individual legal advice. Please have the privacy policy reviewed legally before publication.",
      },
    },
    footer: {
      tagline: "Premium biochar from controlled European Paulownia biomass.",
      rights: "All rights reserved.",
      brandLine: "NeroChar is a division of SRC Global GmbH.",
      partnersTitle: "Partners & standards",
      contactTitle: "Contact",
      agb: "Terms & Conditions",
      privacy: "Privacy Policy",
    },
  },

  fr: {
    nav: {
      home: "Accueil",
      biochar: "Biochar",
      production: "Production",
      applications: "Applications",
      documentation: "Documentation",
      market: "Marché",
      contact: "Contact",
      team: "Équipe",
      menu: "Menu",
      cta: "Demander un volume",
    },
    hero: {
      badge: "SRC Global GmbH · Climate-Tech & Carbon Removal",
      titleLine1: "Black Carbon.",
      titleLine2: "Green Future.",
      subtitle:
        "Biochar premium issu d'une biomasse de paulownia européenne contrôlée – pour l'amélioration des sols, la remise en état, le stockage du carbone et les applications professionnelles.",
      ctaPrimary: "Demander un volume",
      ctaSecondary: "Voir la documentation",
      imageCaption: "Biochar · Paulownia",
      imageTag: "Macro",
      stats: [
        { value: "EBC", label: "qualité orientée" },
        { value: "100%", label: "biomasse européenne" },
        { value: "MRV", label: "lots documentés" },
      ],
    },
    strategic: {
      label: "Matière première stratégique",
      title: "Le biochar – d'un produit de niche à une matière première stratégique.",
      text: "Le biochar évolue d'un produit de niche vers une matière première stratégique. Il est physiquement présent, stockable, transportable, utilisable et documentable – un produit réel et négociable, avec des applications dans l'agriculture, les substrats, l'amélioration des sols, la remise en état et l'élimination du carbone.",
      attributes: ["Physiquement présent", "Stockable", "Transportable", "Utilisable", "Documentable"],
    },
    production: {
      label: "Approche de production",
      title: "Une production contrôlée – de la biomasse au biochar documenté.",
      text: "NeroChar combine culture contrôlée, gestion en interne, pyrolyse, analyses en laboratoire et commercialisation internationale pour créer un produit physique à l'origine claire et à la production traçable.",
      steps: [
        { title: "Culture contrôlée de paulownia", text: "Surfaces de culture définies en Croatie." },
        { title: "Gestion et contrôle qualité en interne", text: "Responsabilité de bout en bout sur la biomasse." },
        { title: "Production par pyrolyse", text: "Transformation en l'absence d'oxygène." },
        { title: "Analyses de laboratoire et documentation des lots", text: "Paramètres de qualité mesurables et traçables." },
        { title: "Commercialisation internationale", text: "Livraison B2B à des acheteurs professionnels." },
      ],
    },
    advantages: {
      label: "Avantages",
      title: "Les avantages du biochar.",
      subtitle: "Quatre propriétés qui font du biochar une matière première de haute qualité et documentable.",
      cards: [
        { title: "Poreux", text: "Grande surface interne possible." },
        { title: "Durable", text: "Stockage du carbone à long terme." },
        { title: "Rétention d'eau", text: "Favorise la rétention d'eau dans le sol." },
        { title: "Documentable", text: "Basé sur les lots, mesurable et traçable." },
      ],
    },
    applications: {
      label: "Applications",
      title: "Une matière première pour le sol, l'agriculture et le climat.",
      subtitle: "Le biochar de NeroChar s'utilise sur toute la chaîne de valeur des projets professionnels de sols et de carbone.",
      items: [
        { title: "Agriculture", text: "Structure du sol et gestion des nutriments." },
        { title: "Amélioration des sols", text: "Activation et valorisation des sols." },
        { title: "Remise en état", text: "Restauration des terres dégradées." },
        { title: "Agroforesterie", text: "Systèmes agricoles et forestiers intégrés." },
        { title: "Substrats", text: "Composant de substrat de haute qualité." },
        { title: "Stockage du carbone", text: "Séquestration du carbone à long terme." },
        { title: "Projets d'élimination du carbone", text: "Performance de puits documentée." },
        { title: "Applications professionnelles de projet", text: "Volumes de projet sur mesure." },
      ],
    },
    certification: {
      label: "Certification & MRV",
      title: "La confiance par des normes reconnues et une documentation traçable.",
      text: "NeroChar aligne sa production sur des normes et méthodologies reconnues – notamment le European Biochar Certificate, la méthodologie Puro.earth Biochar et une approche de documentation orientée MRV.",
      standards: [
        { name: "European Biochar Certificate", abbr: "EBC" },
        { name: "Puro.earth Biochar Methodology", abbr: "Puro.earth" },
        { name: "Measurement, Reporting & Verification", abbr: "MRV" },
      ],
      mrvTitle: "La documentation MRV comprend",
      mrv: [
        "Origine documentée de la biomasse",
        "Logique de lots claire",
        "Données de production de la pyrolyse",
        "Analyses de laboratoire",
        "Paramètres de qualité",
        "Preuve d'utilisation ou de commercialisation",
        "Documentation du stockage du carbone",
        "Prévention du double comptage",
      ],
    },
    market: {
      label: "Marché & potentiel de valeur",
      title: "Valeur de marché & positionnement premium.",
      text: "Le prix de marché du biochar dépend de plusieurs facteurs. NeroChar se positionne comme un biochar premium, de haute qualité et documenté, pour des applications professionnelles de sol, de remise en état et de stockage du carbone.",
      driversTitle: "Facteurs de prix et de valeur",
      drivers: ["Qualité", "Granulométrie", "Certification", "Volume", "Application", "Capacité de livraison"],
    },
    whyNero: {
      label: "Pourquoi NeroChar",
      title: "Un produit premium documenté et négociable – à l'origine claire.",
      points: [
        "Origine contrôlée",
        "Biomasse de paulownia européenne",
        "Production en Croatie",
        "Contrôle qualité en interne",
        "Produit physique et négociable",
        "Documentation selon des normes professionnelles",
        "Commercialisation internationale",
        "Pertinent pour les sols, le climat et les marchés de matières premières",
      ],
    },
    comingSoon: {
      label: "Coming Soon",
      badge: "En développement",
      title: "La première application pour une production de biochar transparente.",
      subtitle: "Prix du marché, documentation des lots et preuves de stockage du carbone – regroupés de manière transparente dans une seule application.",
      features: ["Prix en temps réel", "Documentation des lots", "Stockage du carbone", "Transparence MRV"],
    },
    contact: {
      label: "Demande de projet",
      title: "Parlons ensemble de biochar, de volumes de projet et d'applications de stockage du carbone.",
      subtitle: "Nous conseillons les entreprises, les partenaires de projet et les acteurs de l'élimination du carbone sur la qualité, les volumes et la documentation.",
      form: {
        name: "Nom",
        company: "Entreprise",
        email: "E-mail",
        phone: "Téléphone",
        interest: "Domaine d'intérêt",
        interestOptions: ["Amélioration des sols", "Remise en état", "Stockage du carbone", "Substrats / Agriculture", "Investissement / Partenariat", "Autre"],
        message: "Votre message",
        submit: "Envoyer la demande",
        sending: "Envoi en cours …",
        success: "Merci ! Votre demande a été envoyée. Nous vous répondrons sous peu.",
        error: "Une erreur s'est produite. Veuillez réessayer ou écrire à info@nerochar.com.",
        namePh: "Prénom et nom",
        companyPh: "Nom de l'entreprise",
        emailPh: "nom@entreprise.com",
        phonePh: "+41 ...",
        messagePh: "Décrivez brièvement votre projet, les volumes et le calendrier.",
      },
      companyTitle: "Coordonnées",
      company: "SRC Global GmbH",
      address1: "Chaltenbodenstrasse 26",
      address2: "8834 Schindellegi, Suisse",
      phoneLabel: "Téléphone",
      phone: "044 722 32 35",
      emailLabel: "E-mail",
      email: "info@nerochar.com",
    },
    video: {
      label: "Aperçu",
      title: "NeroChar en mouvement.",
    },
    team: {
      overline: "Notre équipe",
      titleLine1: "Les personnes",
      titleLine2: "derrière la vision",
      intro: "Une équipe d'experts interdisciplinaire réunit une expérience en foresterie, technologie, finance et durabilité pour faire progresser l'industrie de l'élimination du carbone en Europe.",
      members: [
        { name: "Gerold Alexander Auer", role: "Conseil d'administration", img: "/team/auer.png" },
        { name: "Egzon Imeri", role: "Membre de la direction", img: "/team/imeri.png" },
        { name: "Mario Marjanovic", role: "Membre de la direction", img: "/team/marjanovic.png" },
        { name: "Tobias Häppt", role: "Membre de la direction", img: "/team/haeppt.png" },
        { name: "Stéphane Garcia", role: "Membre de la direction", img: "/team/garcia.png" },
        { name: "Katharina Goldsachs", role: "Relations clients", img: "/team/goldsachs.png" },
      ],
    },
    legal: {
      agb: {
        kicker: "Mentions légales",
        title: "Conditions générales",
        updated: "Mise à jour : juin 2026",
        sections: [
          { h: "Champ d'application", body: ["Les présentes conditions générales (CG) s'appliquent à toutes les relations commerciales, offres, livraisons et prestations de NeroChar, une division de SRC Global GmbH (« NeroChar »). Les conditions divergentes du client ne s'appliquent que si NeroChar les a expressément acceptées par écrit."] },
          { h: "Partie contractante", body: ["La partie contractante est SRC Global GmbH, Chaltenbodenstrasse 26, 8834 Schindellegi, Suisse."] },
          { h: "Offres et conclusion du contrat", body: ["Les offres de NeroChar sont sans engagement, sauf si elles sont expressément désignées comme fermes. Un contrat n'est conclu qu'à la confirmation écrite de la commande par NeroChar ou à l'exécution de la livraison."] },
          { h: "Prix et paiement", body: ["Sauf indication contraire, tous les prix s'entendent hors taxe sur la valeur ajoutée ainsi que hors frais d'emballage, de transport et d'assurance. Les factures sont payables sans déduction dans le délai convenu."] },
          { h: "Livraison et volumes", body: ["Les délais de livraison et les volumes de projet sont convenus individuellement. Les livraisons partielles sont autorisées dans la mesure où elles sont raisonnables pour le client. Les retards dus à un cas de force majeure autorisent NeroChar à reporter la livraison en conséquence."] },
          { h: "Qualité et documentation", body: ["NeroChar aligne sa production sur des normes reconnues et fournit une documentation par lot. Les spécifications convenues font foi pour la qualité due."] },
          { h: "Réserve de propriété", body: ["Les marchandises livrées restent la propriété de NeroChar jusqu'au paiement intégral."] },
          { h: "Garantie et responsabilité", body: ["Les défauts apparents doivent être signalés par écrit immédiatement après réception de la marchandise. La responsabilité de NeroChar se limite, dans la mesure permise par la loi, à l'intention et à la négligence grave."] },
          { h: "Droit applicable et for", body: ["Le droit suisse s'applique exclusivement, à l'exclusion de la Convention des Nations Unies sur les contrats de vente internationale de marchandises (CVIM). Le for est, dans la mesure permise par la loi, le siège de SRC Global GmbH."] },
        ],
        note: "Remarque : ce texte est un modèle général et ne constitue pas un conseil juridique individuel. Veuillez faire vérifier les conditions générales par un juriste avant leur publication.",
      },
      privacy: {
        kicker: "Mentions légales",
        title: "Politique de confidentialité",
        updated: "Mise à jour : juin 2026",
        sections: [
          { h: "Responsable du traitement", body: ["Le responsable du traitement des données sur ce site web est SRC Global GmbH (NeroChar), Chaltenbodenstrasse 26, 8834 Schindellegi, Suisse.", "Téléphone : 044 722 32 35 · E-mail : info@nerochar.com"] },
          { h: "Principes", body: ["Nous traitons vos données personnelles de manière confidentielle et conformément aux dispositions légales sur la protection des données, notamment la loi suisse sur la protection des données (LPD) et, le cas échéant, le règlement général européen sur la protection des données (RGPD)."] },
          { h: "Collecte et traitement des données", body: ["Lors de la visite de notre site web, des données techniquement nécessaires (par ex. adresse IP, type de navigateur, moment de l'accès) sont automatiquement enregistrées afin d'assurer le fonctionnement et la sécurité du site."] },
          { h: "Formulaire de contact", body: ["Lorsque vous nous envoyez une demande via le formulaire de contact, nous traitons les données que vous fournissez (par ex. nom, entreprise, e-mail, téléphone, message) exclusivement pour traiter votre demande."] },
          { h: "Cookies", body: ["Ce site web peut utiliser des cookies nécessaires au fonctionnement et à l'amélioration du service. Vous pouvez configurer votre navigateur pour refuser ou supprimer les cookies."] },
          { h: "Transmission à des tiers", body: ["Vos données ne sont transmises à des tiers que dans la mesure où cela est nécessaire à l'exécution du contrat ou qu'il existe une base légale."] },
          { h: "Vos droits", body: ["Vous avez le droit d'accès, de rectification, de suppression ainsi que de limitation du traitement de vos données personnelles. Veuillez pour cela vous adresser à info@nerochar.com."] },
          { h: "Sécurité des données", body: ["Nous prenons des mesures techniques et organisationnelles appropriées pour protéger vos données contre la perte, l'utilisation abusive et l'accès non autorisé."] },
          { h: "Modifications", body: ["Nous nous réservons le droit d'adapter la présente politique de confidentialité afin de la mettre en conformité avec l'évolution de la législation ou des fonctionnalités du site."] },
        ],
        note: "Remarque : ce texte est un modèle général et ne constitue pas un conseil juridique individuel. Veuillez faire vérifier la politique de confidentialité par un juriste avant sa publication.",
      },
    },
    footer: {
      tagline: "Biochar premium issu d'une biomasse de paulownia européenne contrôlée.",
      rights: "Tous droits réservés.",
      brandLine: "NeroChar est une division de SRC Global GmbH.",
      partnersTitle: "Partenaires & normes",
      contactTitle: "Contact",
      agb: "CGV",
      privacy: "Confidentialité",
    },
  },
};
